import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  category: [],
  cardList: [],
  subscriptionList: {
    list: {
      data: [],
      total: 0,
    },
  },
  subscriptionListPaginationMeta: {
    total: 0,
  },
  subscriptionDetail: {},
  autoshipShippingCycle: {},
  cardinfo: {},
  autoshipPaymentInfo: null,
  autoshipData: false,
}
export default {
  state,
  actions,
  mutations,
  getters,
}
